module.exports = __webpack_public_path__ + "c2951f7d4dd43bca2bb09392587a237d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/groups/ShopTechWhite.jpg
// module id = 1292
// module chunks = 0